import { Triangle } from "./Vertex";

const SCALE = 3;
const X_OFFSET = 1100;
const Y_OFFSET = 500;

export let triangles: Triangle[] = [
  /* EARS */
  { x1: 533, y1: 239, x2: 552, y2: 225, x3: 546, y3: 218, fill: "#151110" },
  { x1: 568, y1: 222, x2: 552, y2: 225, x3: 546, y3: 218, fill: "#231E20" },
  { x1: 568, y1: 222, x2: 552, y2: 225, x3: 558, y3: 245, fill: "#151110" },
  { x1: 568, y1: 222, x2: 558, y2: 245, x3: 581, y3: 227, fill: "#231E20" },
  { x1: 573, y1: 249, x2: 558, y2: 245, x3: 581, y3: 227, fill: "#151110" },
  { x1: 573, y1: 249, x2: 558, y2: 245, x3: 573, y3: 262, fill: "#231E20" },
  { x1: 573, y1: 249, x2: 588, y2: 231, x3: 581, y3: 227, fill: "#231E20" },
  { x1: 573, y1: 249, x2: 588, y2: 231, x3: 573, y3: 262, fill: "#151110" },
  { x1: 683, y1: 249, x2: 670, y2: 257, x3: 648, y3: 225, fill: "#231E20" },
  { x1: 683, y1: 249, x2: 670, y2: 218, x3: 648, y3: 225, fill: "#151110" },
  { x1: 683, y1: 249, x2: 670, y2: 218, x3: 688, y3: 236, fill: "#231E20" },
  { x1: 690, y1: 224, x2: 688, y2: 213, x3: 670, y3: 218, fill: "#231E20" },
  { x1: 690, y1: 224, x2: 688, y2: 236, x3: 670, y3: 218, fill: "#151110" },
  { x1: 690, y1: 224, x2: 688, y2: 213, x3: 706, y3: 229, fill: "#151110" },

  /* BODY */
  { x1: 589, y1: 252, x2: 588, y2: 231, x3: 573, y3: 262, fill: "#32302D" },
  { x1: 589, y1: 252, x2: 588, y2: 231, x3: 603, y3: 234, fill: "#6A6462" },
  { x1: 615, y1: 222, x2: 588, y2: 231, x3: 603, y3: 234, fill: "#32302D" },
  { x1: 615, y1: 222, x2: 629, y2: 237, x3: 603, y3: 234, fill: "#6A6462" },
  { x1: 615, y1: 222, x2: 629, y2: 237, x3: 648, y3: 225, fill: "#32302D" },
  { x1: 653, y1: 254, x2: 629, y2: 237, x3: 648, y3: 225, fill: "#6A6462" },
  { x1: 653, y1: 254, x2: 670, y2: 257, x3: 648, y3: 225, fill: "#32302D" },
  { x1: 589, y1: 252, x2: 629, y2: 237, x3: 603, y3: 234, fill: "#32302D" },
  { x1: 589, y1: 252, x2: 629, y2: 237, x3: 620, y3: 252, fill: "#141213" },
  { x1: 653, y1: 254, x2: 629, y2: 237, x3: 620, y3: 252, fill: "#32302D" },
  { x1: 576, y1: 284, x2: 589, y2: 252, x3: 573, y3: 262, fill: "#231E20" },
  { x1: 576, y1: 284, x2: 589, y2: 252, x3: 585, y3: 281, fill: "#6A6462" },
  { x1: 593, y1: 276, x2: 589, y2: 252, x3: 585, y3: 281, fill: "#231E20" },
  { x1: 593, y1: 276, x2: 589, y2: 252, x3: 597, y3: 265, fill: "#141213" },
  { x1: 620, y1: 252, x2: 589, y2: 252, x3: 597, y3: 265, fill: "#32302D" },
  { x1: 593, y1: 276, x2: 599, y2: 282, x3: 597, y3: 265, fill: "#32302D" },
  { x1: 620, y1: 252, x2: 599, y2: 282, x3: 597, y3: 265, fill: "#141213" },
  { x1: 620, y1: 252, x2: 599, y2: 282, x3: 615, y3: 279, fill: "#32302D" },
  { x1: 600, y1: 290, x2: 599, y2: 282, x3: 615, y3: 279, fill: "#141213" },
  { x1: 620, y1: 252, x2: 653, y2: 254, x3: 615, y3: 279, fill: "#141213" },
  { x1: 600, y1: 290, x2: 610, y2: 303, x3: 615, y3: 279, fill: "#32302D" },
  { x1: 631, y1: 289, x2: 610, y2: 303, x3: 615, y3: 279, fill: "#141213" },
  { x1: 631, y1: 289, x2: 634, y2: 279, x3: 615, y3: 279, fill: "#32302D" },
  { x1: 653, y1: 254, x2: 634, y2: 279, x3: 615, y3: 279, fill: "#6A6462" },
  { x1: 653, y1: 254, x2: 634, y2: 279, x3: 645, y3: 274, fill: "#32302D" },
  { x1: 653, y1: 254, x2: 670, y2: 257, x3: 645, y3: 274, fill: "#141213" },
  { x1: 651, y1: 281, x2: 670, y2: 257, x3: 645, y3: 274, fill: "#32302D" },
  { x1: 651, y1: 281, x2: 670, y2: 257, x3: 674, y3: 282, fill: "#141213" },
  { x1: 651, y1: 281, x2: 656, y2: 321, x3: 674, y3: 282, fill: "#32302D" },
  { x1: 651, y1: 281, x2: 656, y2: 321, x3: 642, y3: 290, fill: "#141213" },
  { x1: 631, y1: 289, x2: 656, y2: 321, x3: 642, y3: 290, fill: "#32302D" },
  { x1: 631, y1: 289, x2: 611, y2: 328, x3: 610, y3: 303, fill: "#6A6462" },
  { x1: 631, y1: 289, x2: 611, y2: 328, x3: 625, y3: 329, fill: "#141213" },
  { x1: 600, y1: 290, x2: 611, y2: 328, x3: 610, y3: 303, fill: "#141213" },
  { x1: 600, y1: 290, x2: 611, y2: 328, x3: 589, y3: 291, fill: "#32302D" },
  { x1: 576, y1: 284, x2: 611, y2: 328, x3: 589, y3: 291, fill: "#6A6462" },
  { x1: 576, y1: 284, x2: 589, y2: 291, x3: 585, y3: 281, fill: "#32302D" },
  { x1: 631, y1: 289, x2: 629, y2: 339, x3: 656, y3: 321, fill: "#141213" },
  { x1: 631, y1: 289, x2: 625, y2: 329, x3: 629, y3: 339, fill: "#6A6462" },
  { x1: 637, y1: 350, x2: 629, y2: 339, x3: 656, y3: 321, fill: "#32302D" },
  { x1: 637, y1: 350, x2: 629, y2: 339, x3: 626, y3: 358, fill: "#141213" },
  { x1: 623, y1: 349, x2: 629, y2: 339, x3: 626, y3: 358, fill: "#32302D" },
  { x1: 623, y1: 349, x2: 609, y2: 348, x3: 626, y3: 358, fill: "#141213" },
  { x1: 603, y1: 355, x2: 609, y2: 348, x3: 626, y3: 358, fill: "#32302D" },
  { x1: 603, y1: 355, x2: 609, y2: 348, x3: 584, y3: 318, fill: "#6A6462" },
  { x1: 599, y1: 326, x2: 609, y2: 348, x3: 584, y3: 318, fill: "#141213" },
  { x1: 599, y1: 326, x2: 609, y2: 348, x3: 607, y3: 337, fill: "#32302D" },
  { x1: 599, y1: 326, x2: 611, y2: 328, x3: 607, y3: 337, fill: "#141213" },
  { x1: 584, y1: 318, x2: 611, y2: 328, x3: 599, y3: 326, fill: "#32302D" },
  { x1: 584, y1: 318, x2: 611, y2: 328, x3: 576, y3: 284, fill: "#32302D" },

  /* EYES */
  { x1: 590, y1: 288, x2: 589, y2: 291, x3: 585, y3: 281, fill: "#736B68" },
  { x1: 590, y1: 288, x2: 589, y2: 291, x3: 600, y3: 290, fill: "#736B68" },
  { x1: 590, y1: 288, x2: 593, y2: 276, x3: 585, y3: 281, fill: "#3C2F25" },
  { x1: 597, y1: 280, x2: 591, y2: 282, x3: 597, y3: 284, fill: "#141213" },
  { x1: 597, y1: 280, x2: 599, y2: 282, x3: 597, y3: 284, fill: "#3C2F25" },
  { x1: 590, y1: 288, x2: 591, y2: 282, x3: 597, y3: 284, fill: "#3C2F25" },
  { x1: 593, y1: 276, x2: 591, y2: 282, x3: 597, y3: 280, fill: "#3C2F25" },
  { x1: 590, y1: 288, x2: 600, y2: 290, x3: 599, y3: 282, fill: "#3C2F25" },
  { x1: 631, y1: 289, x2: 642, y2: 290, x3: 641, y3: 288, fill: "#736B68" },
  { x1: 651, y1: 281, x2: 642, y2: 290, x3: 641, y3: 288, fill: "#736B68" },
  { x1: 639, y1: 279, x2: 639, y2: 283, x3: 644, y3: 280, fill: "#141213" },
  { x1: 631, y1: 289, x2: 634, y2: 279, x3: 639, y3: 283, fill: "#3C2F25" },
  { x1: 631, y1: 289, x2: 641, y2: 288, x3: 639, y3: 283, fill: "#3C2F25" },
  { x1: 651, y1: 281, x2: 641, y2: 288, x3: 639, y3: 283, fill: "#3C2F25" },
  { x1: 651, y1: 281, x2: 644, y2: 280, x3: 639, y3: 283, fill: "#3C2F25" },
  { x1: 645, y1: 274, x2: 639, y2: 279, x3: 634, y3: 279, fill: "#3C2F25" },
  { x1: 645, y1: 274, x2: 639, y2: 279, x3: 644, y3: 280, fill: "#3C2F25" },
  { x1: 645, y1: 274, x2: 651, y2: 281, x3: 644, y3: 280, fill: "#3C2F25" },
  { x1: 639, y1: 279, x2: 639, y2: 283, x3: 634, y3: 279, fill: "#3C2F25" },

  /* NOSE */
  { x1: 607, y1: 337, x2: 625, y2: 329, x3: 611, y3: 328, fill: "#32302D" },
  { x1: 607, y1: 337, x2: 625, y2: 329, x3: 609, y3: 348, fill: "#130C0A" },
  { x1: 623, y1: 349, x2: 625, y2: 329, x3: 609, y3: 348, fill: "#130C0A" },
  { x1: 623, y1: 349, x2: 625, y2: 329, x3: 629, y3: 339, fill: "#130C0A" },
];

triangles = triangles.map((tri) => {
  return {
    x1: tri.x1 * SCALE - X_OFFSET,
    y1: tri.y1 * SCALE - Y_OFFSET,
    x2: tri.x2 * SCALE - X_OFFSET,
    y2: tri.y2 * SCALE - Y_OFFSET,
    x3: tri.x3 * SCALE - X_OFFSET,
    y3: tri.y3 * SCALE - Y_OFFSET,
    fill: tri.fill,
  };
});

export let spots = [
  [533, 239],
  [552, 225],
  [546, 218],
  [568, 222],
  [558, 245],
  [581, 227],
  [573, 249],
  [573, 262],
  [588, 231],
  [589, 252],
  [603, 234],
  [615, 222],
  [629, 237],
  [648, 225],
  [653, 254],
  [670, 257],
  [683, 249],
  [670, 218],
  [688, 236],
  [706, 229],
  [690, 224],
  [620, 252],
  [576, 284],
  [585, 281],
  [593, 276],
  [597, 265],
  [599, 282],
  [615, 279],
  [600, 290],
  [610, 303],
  [590, 288],
  [589, 291],
  [631, 289],
  [634, 279],
  [645, 274],
  [651, 281],
  [639, 279],
  [639, 283],
  [644, 280],
  [642, 290],
  [641, 288],
  [674, 282],
  [656, 321],
  [611, 328],
  [584, 318],
  [625, 329],
  [629, 339],
  [637, 350],
  [626, 358],
  [623, 349],
  [609, 348],
  [603, 355],
  [599, 326],
  [607, 337],
  [597, 280],
  [591, 282],
  [597, 284],
  [688, 213],
];

spots = spots.map((spot) => [
  spot[0] * SCALE - X_OFFSET,
  spot[1] * SCALE - Y_OFFSET,
]);
